import React from "react";

import classes from "./DashboardStats.module.css";
import DashboardCard from "../DashboardCard";
import { TotalBooking,ReceivePaymentIcon, ReceivedAmountIcon ,NewSignupIcon,CourtPerformanceIcon} from "../../constant";
import { Row ,Col} from "react-bootstrap";
import {formatNumberWithCommas} from "../../helpers";

const derivePeriod = (period) => {
  if(period === 1){
    return "Today"
  }   
  if(period === 2){
    return "This Week"    
  }
    if(period === 3){
    return "This Month"
  }
  return "This Year"
}
const DashboardStats = ({data,period}) => {
  console.log("PP",period)
  return (
    // <Row className={classes.row}>
    <>
      <Col sm={5} md={7} lg={7}>
      <DashboardCard
      title={"Bookings Stats"}
        icon={<TotalBooking />}
        list={[
          {
            label: "Total Booking",
            value: data?.totalBookings,
            valueLabel: `Booking(s) ${derivePeriod(period)}`,
          },
          {
            label: "Pending Booking",
            value: data?.pendingBookings,
            valueLabel: `Pending Booking(s)`,
          },
          {
            label: "Cancelled Booking",
            value: data?.cancelledBookings,
            valueLabel: `Cancellation(s)  ${derivePeriod(period)}`,
          },
        ]}
      />
      </Col>
       <Col sm={5} md={5} lg={5}>
       <DashboardCard
       title={"Revenue Stats"}
        icon={<ReceivedAmountIcon />}
        list={[
          {
            label: "Total Revenue",
            value: `Rs. ${formatNumberWithCommas(data?.totalRevenue)}`,
                valueLabel: `${derivePeriod(period)}`,
          },
          {
            label: "Unpaid Amount",
            value: `Rs. ${formatNumberWithCommas(data?.unpaidAmount)}`,
            valueLabel: `Pending Payment(s)`,
          },
         
        ]}
      />
      </Col>
      <Col sm={5} md={5} lg={5}>
       <DashboardCard
       title={"User Stats"}
        icon={<NewSignupIcon />}
        list={[
          {
            label: "Total Users",
            value: `${formatNumberWithCommas(data?.totalUsers)}`,
            valueLabel: "Registered User(s)",
          },
          {
            label: "New Users",
            value: formatNumberWithCommas(data?.newUsers),
            valueLabel: `New User(s) ${derivePeriod(period)}`,
          },
         
        ]}
      />
      
      </Col>
      <Col sm={5} md={7} lg={7}>
      <DashboardCard
      title={"Court Performance"}
        icon={<CourtPerformanceIcon />}
        list={[
          {
            label: "Most Booked Court",
            value: `${data?.mostBookedCourt?.court?.courtName || "N/A"} (${formatNumberWithCommas(data?.mostBookedCourt?.bookingCount || 0)||0})`,
            valueLabel: `Booking(s) ${derivePeriod(period)}`,
          },
          {
            label: "Least Booked Court",
            value: `${data?.leastBookedCourt?.court?.courtName || "N/A"} (${formatNumberWithCommas(data?.leastBookedCourt?.bookingCount || 0)||0})`,
            valueLabel: `Booking(s) ${derivePeriod(period)}`,
          },
        
        ]}
      />
      </Col>
      </>
  );
};

export default DashboardStats;
